import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchCategories = createAsyncThunk('fetchCategories', async (type, { getState, rejectWithValue }) => {
  try {
    const { data, status } = await api.get('/settings/categories/' + type);
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch categories'));
  }
});

export const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    data: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.data = {
          ...state.data,
          [action.meta.arg]: action.payload.data
        };
      });
  }
});

export const getCategories = (state, type) => state.categories.data?.[type];

export { fetchCategories };

export default categoriesSlice.reducer;
